import { Network } from '@capacitor/network';

export const checkIsOnline = (): Promise<boolean> => Network.getStatus().then((status) => status.connected);

